import { ParticleSystem, type Particle } from './ParticleSystem';

export class DustParticleSystem extends ParticleSystem {
  constructor(maxParticles: number = 300) {
    super(maxParticles);
  }

  public update(deltaTime: number): void {
    super.update(deltaTime);

    // Apply gravity and drag to dust particles
    for (const p of this.particles) {
      // Gravity (fall down)
      p.vz -= 8.0 * deltaTime;

      // Air resistance
      p.vx *= 0.98;
      p.vy *= 0.98;
      p.vz *= 0.98;
    }
  }

  public emitDustBurst(
    x: number,
    y: number,
    z: number,
    intensity: number = 1.0
  ): void {
    // Emit multiple particles in a burst
    const numParticles = Math.floor(5 + intensity * 10);

    for (let i = 0; i < numParticles; i++) {
      const angle = Math.random() * Math.PI * 2;
      const speed = 2 + Math.random() * 4;
      const upSpeed = 2 + Math.random() * 3;

      const particle: Particle = {
        x: x + (Math.random() - 0.5) * 0.5,
        y: y + (Math.random() - 0.5) * 0.5,
        z: z + Math.random() * 0.3,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        vz: upSpeed,
        life: 0.3 + Math.random() * 0.7,
        maxLife: 0.3 + Math.random() * 0.7,
        size: 0.2 + Math.random() * 0.3,
        r: 0.85 + Math.random() * 0.1,
        g: 0.75 + Math.random() * 0.1,
        b: 0.6 + Math.random() * 0.1,
        alpha: 0.6,
      };

      this.emit(particle);
    }
  }
}
